
export const BASE_API_NODE = process.env.REACT_APP_API_NODE_URL
export const BASE_API = process.env.REACT_APP_API_URL
// export const BASE_API = 'https://cartaz.matrixprint.com.br/api/'
//  export const BASE_API_NODE = 'https://cartaz.matrixprint.com.br/node'